import get from 'lodash/get';
import upperFirst from 'lodash/upperFirst';

type KeysOfUnion<T> = T extends unknown ? keyof T : never;

type LowerFirst<S extends string> = S extends `${infer F}${infer R}` ? `${Lowercase<F>}${R}` : S;

/**
 * Get the value of a key from an object
 * ignoring whether the key is written in camelCase or PascalCase.
 */
export const keyOf = <Object extends object, Key extends LowerFirst<KeysOfUnion<Object> & string>>(
    obj: Object,
    key: Key
) => {
    return get(obj, key as string) ?? get(obj, upperFirst(key as string));
};
